import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ConsoleLogger, ILogger } from './logger.interface';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private cachedVersion: string | null = null;
  private readonly logger: ILogger;

  constructor(
    private readonly meta: Meta
  ) {
    this.logger = new ConsoleLogger();
  }

  public getVersion(): string {
    if (this.cachedVersion !== null) {
      return this.cachedVersion;
    }

    const appVersionTag = this.meta.getTag('name=application-version');
    if (appVersionTag) {
      this.cachedVersion = appVersionTag.content;
      this.logger.log('[VersionService] Version from Angular Meta service:', this.cachedVersion);
      return this.cachedVersion;
    }

    this.logger.warn('[VersionService] Could not find application-version meta tag');
    const availableMetaTags = Array.from(document.querySelectorAll('meta[name]'))
      .map(el => `${el.getAttribute('name')}=${el.getAttribute('content')}`);
    this.logger.warn('[VersionService] Available meta tags:', availableMetaTags);

    this.cachedVersion = '';
    return this.cachedVersion;
  }

  /**
   * Clears the cached version, forcing the next getVersion() call to re-fetch from meta tags.
   * Useful when the version meta tag may be dynamically updated after initial load.
   */
  public clearCache(): void {
    this.cachedVersion = null;
  }
}

